import { render, staticRenderFns } from "./ContactTabs.vue?vue&type=template&id=11b1c56c&scoped=true&"
import script from "./ContactTabs.vue?vue&type=script&lang=js&"
export * from "./ContactTabs.vue?vue&type=script&lang=js&"
import style0 from "./ContactTabs.vue?vue&type=style&index=0&id=11b1c56c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b1c56c",
  null
  
)

export default component.exports